import { useMemo } from 'react';
import { contentV1PresetPurgeCacheOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const usePresetPurgeCache = (enabled = true) => {
  const { workspace } = useWorkspace();

  const options = useMemo(
    () => ({
      ...contentV1PresetPurgeCacheOptions({
        ...defaultOptions(),
        path: { workspace },
      }),
    }),
    [workspace],
  );

  const { refetch } = useQuery({
    ...options,
    enabled: !!workspace && enabled,
  });

  return useMutation({
    mutationFn: async () => {
      const result = await refetch();
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
  });
};
